import { setInitialState } from "../../../../utils/reducerOperations";
export function InitialState() {
  return {
    batchQuestionsApi: setInitialState(),
    exploreReducerInitialStateSet:false
  };
}
